export enum LivedataServiceErrorCode {
  GENERAL,
}

export enum LockType {
  Locked = 1,
  NotLocked = 1,
}

export interface LivedataServerData {
  OpenDayStatus: {
    Locked: LockType
    SEC_UserID: null | number
    Cur_Date: string
  }
  [key: string]: any
}
